import React, { Component } from 'react'
import {Breadcrumb as AntBreadCrumb, Button, Icon} from 'antd'
import { Route } from 'react-router-dom';
import {subscribe} from 'alfa';

const routeMap = {
  'business': 'Business',
  'accounts': 'Accounts',
  'transactions': 'Transactions',
  'batches': 'Batches',
  'api-keys': 'API Keys',
  'managers': 'Managers',
  'transfer': 'Bank Transfer',
  'new': 'New',
  'users': 'Users',
};

class Breadcrumb extends Component {
  buildItem = r => {
    let { account } = this.props;
    if (account && account.id === r.name) {
      return account.alias
    }

    return routeMap[r.name] || r.name
  }

  Breadcrumbs = p => <Route path="*" render={props => {
    const { business } = this.props;
    let parts = props.location.pathname.split("/");
    const place = parts[parts.length-1] || "Home";
    parts = parts.slice(1, parts.length-1);

    let result = parts.map((part, partIndex, parts) => {
      const path = ['', ...parts.slice(0, partIndex+1)].join("/");
      return {
        "name": part,
        "url": path,
        "active": false,
      };
    });

    if (result.length > 0 || place !== 'Home') {
      result.unshift({
        name: <><Icon type='home' /> {business ? business.name : 'Home'}</>,
        url: '/',
        active: false,
      });
    }

    result.push({
      "name": place,
      "url": "",
      active: true,
    });

    return (
      <AntBreadCrumb style={{ margin: '16px 0' }}>
        {result.map((r, i) => <AntBreadCrumb.Item key={i}>
          <Button type="link" href={r.url}>{this.buildItem(r)}</Button>
        </AntBreadCrumb.Item>)}
      </AntBreadCrumb>
    )}}
  />;

  render () {
    return <this.Breadcrumbs />
  }
}

export default subscribe(Breadcrumb, ['business', 'account']);